// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c06f8c9c","977":"7ee33602"}[chunkId] + ".chunk.js";
};